import { SurveySettings } from '../../types';
import { apiError } from '../../utils/errors';

export interface TradeReferenceData {
  settings: SurveySettings;
  referenceIsNoLongerRequired: boolean;
}

export const getTradeReferenceData = async (
  accountSlug: string,
  trackingId: string,
): Promise<TradeReferenceData> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/trade-references/${accountSlug}/${trackingId}`,
  );
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch trade reference', responseJson?.code);
  }

  const data = responseJson.data;

  return data;
};
